// import qs from 'qs';
import request from '@/utils/request';

// 查询品类交易额
export async function selOrderVolume(params) {
  return request.post('/api/bigdata/selCategoryAmount', { ...params });
}

// 交易额趋势
export async function tradingVolume(params) {
  return request.post('/api/bigdata/selOrderCategoryBusinessTrend', { ...params });
}

// 店铺排行榜
export async function selTopShop(params) {
  return request.post('/api/trading/shopInfo/selShopBySalesSort', { ...params });
}

// 交易流动
export async function selOrderFlow(params) {
  return request.post('/api/bigdata/selOrderFlow', { ...params });
}

// 用户信息
export async function getUser(params) {
  return request.post('api/basic/member/login/login', { ...params });
}

// 区域信息
export async function selStaffDeptListByParentId(params) {
  return request.post('/api/basic/staffDept/selStaffDeptListByParentId', { ...params })
}
